import { observer } from "mobx-react-lite"
import FileItem, { FileData } from "../../atoms/FileItem"
import styles from "./styles.module.scss"

export const UploadedFilesModal = observer(
  ({
    onClose,
    handlePreview,
    files,
  }: {
    onClose: () => void
    handlePreview: (file: FileData) => void
    files: FileData[]
  }) => {
    return (
      <div className={styles.container}>
        <div className={styles.fileList}>
          {!files.length ? (
            <p className={styles.noFilesText}>No files added yet</p>
          ) : (
            <>
              {files.map((file, index) => (
                <FileItem
                  key={index}
                  file={file}
                  handlePreview={() => {
                    onClose()
                    handlePreview(file)
                  }}
                />
              ))}
            </>
          )}
        </div>
      </div>
    )
  },
)
